/* BUDS cart drawer: רענון בלי לצאת מהעמוד, הסרת מארז שלם, כמות, "הצג פריטים" */
(function () {
  function drawer() { return document.querySelector('cart-drawer'); }
  function inner() { return document.querySelector('cart-drawer .drawer__inner'); }

  async function refresh(open) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var j = await fetch(root + '?sections=cart-drawer,cart-icon-bubble').then(function (r) { return r.json(); });
    var d = drawer(); if (!d) return;
    var doc = new DOMParser().parseFromString(j['cart-drawer'], 'text/html');
    var fresh = doc.querySelector('#CartDrawer');
    if (fresh) document.getElementById('CartDrawer').innerHTML = fresh.innerHTML;
    d.classList.toggle('is-empty', !!doc.querySelector('[data-bcd-empty]'));
    var bub = document.getElementById('cart-icon-bubble');
    if (bub && j['cart-icon-bubble']) {
      var b = new DOMParser().parseFromString(j['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
      if (b) bub.innerHTML = b.innerHTML;
    }
    if (open) d.open();
  }
  window.budsCartRefresh = refresh;

  async function post(url, body) {
    var el = inner(); if (el) el.classList.add('is-busy');
    try {
      await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
      await refresh(false);
    } finally { var e2 = inner(); if (e2) e2.classList.remove('is-busy'); }
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('#CartDrawer-Overlay')) { var d = drawer(); if (d) d.close(); return; }

    var t = e.target.closest('[data-bcd-toggle]');
    if (t) {
      var box = t.closest('.bcd-item').querySelector('.bcd-mix');
      box.hidden = !box.hidden;
      t.setAttribute('aria-expanded', String(!box.hidden));
      return;
    }

    var rm = e.target.closest('[data-bcd-remove]');
    if (rm) {
      e.preventDefault(); rm.disabled = true;
      var updates = {};
      rm.getAttribute('data-bcd-remove').split(',').filter(Boolean).forEach(function (k) { updates[k] = 0; });
      post('/cart/update.js', { updates: updates });
      return;
    }

    var q = e.target.closest('[data-bcd-qty]');
    if (q) {
      e.preventDefault();
      post('/cart/change.js', { id: q.getAttribute('data-bcd-qty'), quantity: Math.max(0, parseInt(q.getAttribute('data-q'), 10) || 0) });
    }
  });
})();
